import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const IconCircleCheckedFilled: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.33334C4.3181 1.33334 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33334 8 1.33334ZM10.4691 6.28643L9.95309 5.86427L6.97525 9.50385L5.66667 8.19527L5.19526 8.66667L7.02475 10.4962L10.4691 6.28643Z"
                fill="currentColor"
            />
        </svg>
    );
};
